import { createAsyncThunk } from '@reduxjs/toolkit';
import Cookies from 'js-cookie';
import { jwtDecode } from 'jwt-decode';

export const checkAuth = createAsyncThunk('auth/checkAuth', async () => {
  const token = Cookies.get('accessToken');
  if (token) {
    try {
      const decoded = jwtDecode(token);
      // const groups = decoded['cognito:groups'];
      // const role = getUserRole(groups);
      const isAuthenticated = decoded.exp * 1000 > Date.now();

      return { isAuthenticated };
    } catch {
      return { isAuthenticated: false, role: null };
    }
  }

  return { isAuthenticated: false, role: null };
});
